import { ITncRepository } from '../../ports/ITncRepository';

export class DownloadRdcUseCase {
  constructor(private readonly tncRepository: ITncRepository) {}

  async execute(caseId: string): Promise<Blob> {
    return this.tncRepository.downloadRdc(caseId);
  }
}
